module.exports = __webpack_public_path__ + "img/20201118.0dd7a77c.webp";